import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { NgForm } from '@angular/forms';
import { TransferEvent } from '../code-transfers.component';
@Component({
  selector: 'app-short-code-transfers-dialog',
  templateUrl: './code-transfer-dialog.component.html',
  styleUrls: ['./code-transfer-dialog.component.scss']
})
export class CodeTransferDialogComponent extends ScrBaseComponent implements OnInit {
  @Input() fromAccountID?: number;
  @Input() scId!: number;

  @Output() transferCodeClick = new EventEmitter<TransferEvent>();

  public transferAgreement = false;
  public toAccountIdValue?: number;

  public display = false;
  @ViewChild('transferForm', { static: false }) transferForm!: NgForm;

  constructor(private shortCodesService: ShortCodesService,) { super(); }

  ngOnInit(): void {
    this.clearErrors();
  }

  resetForm() {
    delete this.toAccountIdValue;
    this.transferAgreement = false;
    this.transferForm.resetForm();
    this.transferForm.form.markAsPristine();
    this.clearMessages();
  }

  cancel() {
    this.display = false;
  }

  showDialog() {
    this.display = true;
  }

  public transferShortCode({ form }: NgForm) {
    form.controls['toAccountId'].markAsTouched();
    if (!this.transferAgreement || this.transferAgreement === null) {
      form.controls['termAgreement'].setErrors({ required: true });
    }
    else {
      form.controls['termAgreement'].setErrors(null);
    }
    form.controls['termAgreement'].markAsTouched();
    if (!form.invalid) {
      this.observe(this.shortCodesService.initiateTransfer(this.scId, this.toAccountIdValue ?? 0), (rsp) => {
        this.transferCodeClick.emit({ scId: this.scId, response: rsp, type: 'Success' });
        return false;
      });
    }
  }


  closeDialog() {
    this.display = false;
  }

  keyPressNumbers(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
